var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.items),function(item,index){return _c('AdditionalItem',_vm._b({key:index,attrs:{"item":item,"index":index,"context":_vm.context}},'AdditionalItem',_vm.$props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }